import { useRef, useCallback } from "react"
import { WebView as RNWebView, WebViewNavigation } from "react-native-webview"

type WebViewProps = {
  url: string
  onSuccess?: (() => void) | null
}

const INJECT_STYLE_SCRIPT = `
(function() {
  var id = "synchpay-accent-style";
  if (document.getElementById(id)) return true;
  var css = ".bg-accent-800{background:linear-gradient(to bottom,#C2D3FB 0%,#FFFFFF 75%)!important;background-color:#FFFFFF!important;}";
  var style = document.createElement("style");
  style.id = id;
  style.type = "text/css";
  style.appendChild(document.createTextNode(css));
  (document.head || document.documentElement).appendChild(style);
  return true;
})();
true;
`

export function WebView({ url, onSuccess }: WebViewProps) {
  const webViewRef = useRef<RNWebView>(null)

  const injectStyle = useCallback(() => {
    webViewRef.current?.injectJavaScript(INJECT_STYLE_SCRIPT)
  }, [])

  const handleWebViewRequest = useCallback(
    (request: { url: string }) => {
      if (request.url.includes("successCreditCardPayment")) {
        onSuccess?.()
        return false
      }
      return true
    },
    [onSuccess]
  )

  const handleNavigationStateChange = useCallback(
    (navState: WebViewNavigation) => {
      injectStyle()
    },
    [injectStyle]
  )

  const handleLoadEnd = useCallback(() => {
    injectStyle()
  }, [injectStyle])

  return (
    <RNWebView
      ref={webViewRef}
      source={{ uri: url }}
      style={{ flex: 1 }}
      startInLoadingState={false}
      injectedJavaScript={INJECT_STYLE_SCRIPT}
      onLoadEnd={handleLoadEnd}
      onNavigationStateChange={handleNavigationStateChange}
      onShouldStartLoadWithRequest={handleWebViewRequest}
    />
  )
}
